import { NavItem } from './nav-item/nav-item';


// This Menu for 'Admin'
export const navItems: NavItem[] = [
  {
    displayName: 'Dashboard',
    iconName: 'layout-dashboard',
    bgcolor: 'accent',
    route: '/dashboards/dashboard',
  },
  {
    displayName: 'Menu Masters',
    iconName: 'settings',
    bgcolor: 'accent',
    route: 'masters',
    children: [
      {
        displayName: 'Category',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'masters/menu-category',
      },
      {
        displayName: 'Item',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'masters/menu-item',
      },
      {
        displayName: 'Ingredients',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'masters/ingredients',
      },
      {
        displayName: 'Customer',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'masters/customers',
      },
      {
        displayName: 'Tables',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'masters/tables',
      },
      {
        displayName: 'Staff',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'masters/staff',
      },
    ]
  },
  {
    displayName: 'Live Billing',
    iconName: 'license',
    bgcolor: 'accent',
    route: '/Admin/billing',
  },
  {
    displayName: 'Live Order',
    iconName: 'flame',
    bgcolor: 'accent',
    route: '/Admin/live-orders',
  },
  {
    displayName: 'Order History',
    iconName: 'history-toggle',
    bgcolor: 'accent',
    route: '/Admin/order-history',
  },
  {
    displayName: 'Reports',
    iconName: 'clipboard-list',
    bgcolor: 'error',
    route: 'reports',
    children: [
      {
        displayName: 'Overall Revenue Summary',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'reports/overall-revenue-summary',
      },
      {
        displayName: 'Product Perfomance',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'reports/product-perfomance',
      },
      {
        displayName: 'Staff Perfomance',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'reports/staff-perfomance',
      },
      {
        displayName: 'CRM Insights',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'reports/crm-insights',
      },
      {
        displayName: 'Cancelled Orders',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'reports/cancelled-orders',
      },
      {
        displayName: 'Table Sales Report',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'reports/table-sales',
      },
    ],
  },
]

// This Menu for 'Manager'
export const navItems2: NavItem[] = [
  {
    displayName: 'Dashboard',
    iconName: 'layout-dashboard',
    bgcolor: 'accent',
    route: '/dashboards/dashboard',
  },
  {
    displayName: 'Menu Masters',
    iconName: 'settings',
    bgcolor: 'accent',
    route: 'masters',
    children: [
      {
        displayName: 'Category',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'masters/menu-category',
      },
      {
        displayName: 'Item',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'masters/menu-item',
      },
      {
        displayName: 'Ingredients',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'masters/ingredients',
      },
      {
        displayName: 'Customer',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'masters/customers',
      },
      {
        displayName: 'Tables',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'masters/tables',
      },
      {
        displayName: 'Staff',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'masters/staff',
      },
    ]
  },
  {
    displayName: 'Live Billing',
    iconName: 'license',
    bgcolor: 'accent',
    route: '/Admin/billing',
  },
  {
    displayName: 'Live Order',
    iconName: 'flame',
    bgcolor: 'accent',
    route: '/Admin/live-orders',
  },
  {
    displayName: 'Order History',
    iconName: 'history-toggle',
    bgcolor: 'accent',
    route: '/Admin/order-history',
  },
  {
    displayName: 'Reports',
    iconName: 'clipboard-list',
    bgcolor: 'error',
    route: 'reports',
    children: [
      {
        displayName: 'Overall Revenue Summary',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'reports/overall-revenue-summary',
      },
      {
        displayName: 'Product Perfomance',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'reports/product-perfomance',
      },
      {
        displayName: 'Staff Perfomance',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'reports/staff-perfomance',
      },
      {
        displayName: 'CRM Insights',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'reports/crm-insights',
      },
      {
        displayName: 'Cancelled Orders',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'reports/cancelled-orders',
      },
      {
        displayName: 'Table Sales Report',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'reports/table-sales',
      },
    ],
  },
]

// This Menu for 'Salesman'
export const navItems3: NavItem[] = [
  {
    displayName: 'Dashboard',
    iconName: 'layout-dashboard',
    bgcolor: 'success',
    route: '/dashboards/dashboard',
  },
  {
    displayName: 'Task',
    iconName: 'list-details',
    bgcolor: 'accent',
    route: 'tasks',
    children: [
      {
        displayName: 'Add Task',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'tasks/add-edit-task/0',
      },
      {
        displayName: 'Pending',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'tasks/task-management/Pending',
      },
      {
        displayName: 'Accepted',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'tasks/task-management/Accepted',
      },
      {
        displayName: 'Started',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'tasks/task-management/Started',
      },
      {
        displayName: 'On Hold',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'tasks/task-management/On Hold',
      },
      {
        displayName: 'Completed',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'tasks/task-management/Completed',
      },
      {
        displayName: 'Cancel',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'tasks/task-management/Cancel',
      },
    ]
  },
  {
    displayName: 'Go To Home',
    iconName: 'home',
    bgcolor: 'success',
    route: 'starter/go-to-home',
  },
  {
    displayName: 'Installer',
    iconName: 'user-cog',
    bgcolor: 'error',
    route: 'starter/installer',
  },
  {
    displayName: 'Notification',
    iconName: 'bell',
    bgcolor: 'warning',
    route: 'starter/notification',
  },
  {
    displayName: 'Masters',
    iconName: 'database-cog',
    bgcolor: 'error',
    route: 'masters',
    children: [
      {
        displayName: 'Products',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'masters/products',
      },
    ]
  },
  {
    displayName: 'Reports',
    iconName: 'clipboard-list',
    bgcolor: 'accent',
    route: 'starter/reports',
    children: [
      {
        displayName: 'Task Report',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'starter/reports/task-report',
      },
      {
        displayName: 'City Wise Task Report',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'starter/reports/city-task-report',
      },
      {
        displayName: 'Payment Summary',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'starter/reports/paid-unpiad-report',
      },
      {
        displayName: 'Location Summary',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'starter/reports/location-summary',
      },
    ],
  },
]

// This Menu for 'Accountant'
export const navItems4: NavItem[] = [
  {
    displayName: 'Dashboard',
    iconName: 'layout-dashboard',
    bgcolor: 'success',
    route: '/dashboards/dashboard',
  },
  {
    displayName: 'User',
    iconName: 'users',
    bgcolor: 'primary',
    route: 'starter/user',
  },
  {
    displayName: 'Expense',
    iconName: 'calendar-dollar',
    bgcolor: 'success',
    route: 'starter/expense',
  },
  {
    displayName: 'Reports',
    iconName: 'clipboard-list',
    bgcolor: 'error',
    route: 'starter/reports',
    children: [
      {
        displayName: 'Expense Report',
        iconName: 'plus',
        bgcolor: 'tranparent',
        route: 'starter/reports/expense-report',
      },
    ],
  },
]